export const team = [
  {
    id: 1,
    name: 'Giuseppe Rossi',
    role: {
      de: 'Küchenchef & Inhaber',
      en: 'Head Chef & Owner'
    },
    bio: {
      de: 'Giuseppe führt die Familientradition in dritter Generation fort. Seine Ausbildung erhielt er in renommierten Restaurants in Rom und Mailand, bevor er 2010 das Bella Vista von seinen Eltern übernahm.',
      en: 'Giuseppe continues the family tradition in the third generation. He trained at renowned restaurants in Rome and Milan before taking over Bella Vista from his parents in 2010.'
    },
    image: 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=400&h=500&fit=crop&crop=face',
    featured: true
  },
  {
    id: 2,
    name: 'Maria Rossi',
    role: {
      de: 'Restaurantleiterin',
      en: 'Restaurant Manager'
    },
    bio: {
      de: 'Maria sorgt dafür, dass sich jeder Gast wie zu Hause fühlt. Mit ihrem Gespür für Details und ihrer herzlichen Art ist sie das Gesicht des Bella Vista.',
      en: 'Maria ensures every guest feels at home. With her eye for detail and warm manner, she is the face of Bella Vista.'
    },
    image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&h=500&fit=crop&crop=face',
    featured: true
  },
  {
    id: 3,
    name: 'Marco Conti',
    role: {
      de: 'Sous Chef',
      en: 'Sous Chef'
    },
    bio: {
      de: 'Marco ist Giuseppes rechte Hand in der Küche. Sein Spezialgebiet sind hausgemachte Pasta und innovative Desserts.',
      en: 'Marco is Giuseppe\'s right-hand in the kitchen. His specialty is homemade pasta and innovative desserts.'
    },
    image: 'https://images.unsplash.com/photo-1583394293214-28ez3c7e3ff6?w=400&h=500&fit=crop&crop=face',
    featured: false
  },
  {
    id: 4,
    name: 'Sofia Valentini',
    role: {
      de: 'Sommelière',
      en: 'Sommelier'
    },
    bio: {
      de: 'Sofia kuratiert unsere Weinkarte mit Sorgfalt und Leidenschaft. Sie berät unsere Gäste zu den perfekten Weinbegleitungen.',
      en: 'Sofia curates our wine list with care and passion. She advises our guests on perfect wine pairings.'
    },
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=500&fit=crop&crop=face',
    featured: false
  },
  {
    id: 5,
    name: 'Luca Ferrara',
    role: {
      de: 'Pizzaiolo',
      en: 'Pizza Chef'
    },
    bio: {
      de: 'Luca beherrscht die Kunst der neapolitanischen Pizza. Jeder Teig wird von Hand geknetet und im Steinofen bei 400°C gebacken.',
      en: 'Luca masters the art of Neapolitan pizza. Every dough is kneaded by hand and baked in a stone oven at 400°C.'
    },
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop&crop=face',
    featured: false
  }
];

export const getFeaturedTeam = () => team.filter(member => member.featured);
